import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions } from '../../../../../store/actions'
import history from '../../../../../route/history'
import Input from '../../../../../module/input'
/*import Calendar from '../../../../../module/component-box/Calendar'*/
import Calendar from '../../../../../module/calendar'
import moment from 'moment'
import { commons } from '../../../../../hook/common'

/**
 * 수출근거서류 등록/수정 팝업
 * @param props
 * @constructor
 */
const PopGetItem = (props) => {
  const [state, setState] = useState({})
  const [itemList, setItemList] = useState([])

  useEffect(() => {
    if (props.packageId === 0) {
      let list = JSON.parse(sessionStorage.getItem(props.docid)).step2

      setItemList(list)
    }
    if (props.packageId > 0) {
      if (props.docid !== undefined) {
        let list = JSON.parse(sessionStorage.getItem(props.docid)).step2

        setItemList(list)
      }
    }
  }, [])

  const handleClose = () => {
    props.isShowItems(false)
  }

  const selectItem = (crtItemSeq) => {
    props.selectItems(crtItemSeq)
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '3',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '4',
    display: 'block',
  }

  return (
    <React.Fragment>
      {/* 수출근거서류 정보 */}
      <div style={style}></div>
      <div style={styleModal} id="purchase-register" className="modal w1120">
        <div className="modal-head">
          <h2>수출근거서류 정보</h2>
        </div>
        <div className="modal-cont">
          <div className="list-header">
            <span className="total-num">총 {itemList?.length}건</span>
          </div>
          <div className="tbl-wrap">
            <table className="tbl-list">
              <caption>HS부호, 품명, 규격, 수량, 구매일, 단가, 금액 항목으로 구성</caption>
              <colgroup>
                <col style={{ width: '13%' }} />
                <col style={{ width: '22%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '13%' }} />
                <col style={{ width: '11%' }} />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">HS부호</th>
                  <th scope="col">품명</th>
                  <th scope="col">규격</th>
                  <th scope="col">수량</th>
                  <th scope="col">구매일</th>
                  <th scope="col">
                    단가
                    <br />({props.currency})
                  </th>
                  <th scope="col">
                    금액
                    <br />({props.currency})
                  </th>
                </tr>
              </thead>
              <tbody>
                {itemList?.length > 0 ? (
                  itemList?.map((item, index) => {
                    return (
                      <tr key={index} onClick={() => selectItem(item.crtItemSeq)}>
                        <td className="cell" data-title={'HS부호'}>
                          {item.hsCd}
                        </td>
                        <td className="cell" data-title={'품명'}>
                          {item.itemnm}
                        </td>
                        <td className="cell" data-title={'규격'}>
                          {item.itemdeftxt}
                        </td>
                        <td className="cell" data-title={'수량'}>
                          {commons.addComma(item.grcnt)}
                        </td>
                        <td className="cell" data-title={'구매일'}>
                          {moment(item.crtYmd).format('YYYY-MM-DD')}
                        </td>
                        <td className="cell" data-title={'단가'}>
                          {commons.addComma(item.baseAmt)}
                        </td>
                        <td className="cell" data-title={'금액'}>
                          {commons.addComma(item.gramt)}
                        </td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <div className="nodata">등록된 자료가 없습니다.</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <button type="button" className="modal-close b-close" onClick={handleClose}>
          창닫기
        </button>
      </div>
      {/* 구매물품 목록 등록/수정 */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    totalData: state.certapply.data,
  }
}

const actionCreators = {
  selectItems: certapplyActions.selectItems,
  isShowItems: certapplyActions.isShowItems,
}

export default connect(mapStateToProps, actionCreators)(PopGetItem)
